export default __webpack_public_path__ + "static/media/gift-cart-active.65768533.svg";